import { FETCH_CATEGORY } from 'src/common/actions/browse';

import createMappedReducer from './utils/createMappedReducer';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';
import createContainerNavigationHandlers from './utils/createContainerNavigationHandlers';

export const categories = createMappedReducer(
  {},
  {
    ...createRequestLifecycleHandlers({ fetchActionNameRoot: FETCH_CATEGORY }),
    ...createContainerNavigationHandlers(),
  },
);
